<template>
  <TextField
    v-if="showInput"
    :class="item.id"
    :disabled="isReadOnlyDialog"
    :rules="[(v) => isInvalidAgainstCommonRules() || isInvalidInteger(v)]"
    @keydown.enter.prevent
    ref="input"
  />
</template>

<script>
import TextField from '@wizer/core/components/text-field/TextField'
import Decimal from 'decimal.js'
import { mapState } from 'vuex'
import Cleave from 'cleave.js'
import NumberFormatMixin from '@/mixins/NumberFormatMixin'
import SustainabilityInputMixin from '@/mixins/SustainabilityInputMixin'

export default {
  name: 'IntegerInput',
  mixins: [SustainabilityInputMixin, NumberFormatMixin],
  components: {
    TextField,
  },
  props: {
    isReadOnlyDialog: Boolean,
    item: Object,
    previouslySaved: Boolean,
    contextValidationMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cleave: null,
    }
  },
  mounted() {
    this.formValues[this.item.id] = this.getLocalizedInputValue(this.inputValue)

    this.cleave = new Cleave(
      `.${this.item.id} .w-text-field__input`,
      this.getCleaveOptions(this.$profile.locale, this.onValueChanged),
    )
  },
  methods: {
    updateValue(value) {
      this.showInput = false
      this.formValues[this.item.id] = value
      this.$refs.input.validate()
      this.$nextTick(() => {
        this.showInput = true
      })
    },
    inputRequiresInitialAdjustment() {
      return true
    },
    onValueChanged(maskedValue) {
      this.formValues[this.item.id] = maskedValue.target.rawValue
      this.$refs.input.validate()
    },
    isInvalidInteger(str) {
      if (this.contextValidationMessage) {
        return this.contextValidationMessage
      }
      // 2 to the power of 31 is the max integer size defined in the old sustainability view
      const intMaxValue = 2 ** 31

      try {
        const decimal = new Decimal(str)
        // Check if parsing was successful, i.e no illegal characters were stripped
        // So that the validation error appears as soon as user add decimal separator symbol
        if (decimal.toNumber().toString().length !== str.toString().length || !decimal.isInt()) {
          return this.$t('validation.notAnInteger')
        }
        // Check if final result is Integer that fits in the bounds
        return (
          (decimal.isInteger() &&
            decimal.toNumber() < intMaxValue &&
            decimal.toNumber() > -intMaxValue &&
            this.isPrecisionKeptAfterSaving(decimal.toNumber().toString())) ||
          this.$t('validation.integerOutOfRange')
        )
      } catch (e) {
        return this.$t('validation.notAnInteger')
      }
    },
  },
  computed: {
    inputValue() {
      return this.formValues[this.item.id]
    },
    ...mapState({
      formValues: (state) => state.SustainabilityData.formValues,
    }),
    inputValueToPost() {
      return {
        inputValue: this.getGlobalizedInputValue(this.inputValue),
        adjusted: true,
      }
    },
  },
}
</script>
